import { Banner } from "#ui/banner";
import { Container } from "#ui/container";
import { Main, type MainProps } from "#ui/main";

import { PageOutageCard } from "./page-outage-card";
import type { UseQueryPageOutageData } from "./use-query-page-outage";

export type PageOutageMainProps = Omit<MainProps, "children"> & {
  children: React.ReactNode;
  data: UseQueryPageOutageData;
};

/**
 * Renders the main content for the outage page.
 * If the outage data indicates that the page is not available,
 * it displays an error message instead of the children content.
 */
export function PageOutageMain({
  children,
  data,
  ...props
}: PageOutageMainProps) {
  if (!!data && data.isAvailable === false) {
    return (
      <Main {...props}>
        <Banner />
        <Container className="grid justify-items-center">
          <PageOutageCard />
        </Container>
      </Main>
    );
  }

  return children;
}
